import { Drawer, DrawerBody, DrawerHeader } from "@/components/drawer";
import { formatGmailInternalDate } from "../../_constants/gmailDisplay.const";
import { useEmailMessageQuery } from "../../_hooks/useEmailMessageQuery";
import type { GmailMessageListItem } from "../../_types/gmail.types";
import styles from "./EmailDetailsDrawer.module.scss";

type EmailDetailsDrawerProps = {
  messageId: string | null;
  summary: GmailMessageListItem | null;
  isOpen: boolean;
  onClose: () => void;
};

export const EmailDetailsDrawer = ({
  messageId,
  summary,
  isOpen,
  onClose,
}: EmailDetailsDrawerProps) => {
  const { data, isLoading, isError } = useEmailMessageQuery(messageId);

  const subject = data?.subject ?? summary?.subject ?? "(No subject)";
  const from = data?.from ?? summary?.from;
  const to = data?.to ?? summary?.to;
  const dateLine =
    data?.date ??
    (summary?.internalDate ? formatGmailInternalDate(summary.internalDate) : null);

  return (
    <Drawer isOpen={isOpen} onClose={onClose} ariaLabel="Email message details">
      <>
        <DrawerHeader
          title={subject}
          subtitle={
            <div className={styles["comp__subtitle"]}>
              {from ? <div>From: {from}</div> : null}
              {to ? <div>To: {to}</div> : null}
              {dateLine ? <div>Date: {dateLine}</div> : null}
            </div>
          }
          onClose={onClose}
        />
        <DrawerBody>
          {isLoading ? <div className={styles["comp__state"]}>Loading full message…</div> : null}
          {isError ? (
            <div className={styles["comp__state"]}>Could not load full message content.</div>
          ) : null}
          {!isLoading && !isError && data ? (
            <>
              {data.bodyHtml ? (
                <iframe
                  title="Email body"
                  sandbox=""
                  srcDoc={data.bodyHtml}
                  className={styles["comp__iframe"]}
                />
              ) : data.bodyText ? (
                <pre className={styles["comp__pre"]}>{data.bodyText}</pre>
              ) : (
                <div className={styles["comp__state"]}>No body content.</div>
              )}
            </>
          ) : null}
        </DrawerBody>
      </>
    </Drawer>
  );
};
